'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:ModalController
 * @description
 * # ModalController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ModalController', ['$uibModalInstance', '$scope', '$rootScope', 'data', '$location',
      function ($uibModalInstance, $scope, $rootScope, data, $location) {
      $scope.data = data;

      $scope.close = function (action) {
          $uibModalInstance.close(action);
      };

      $scope.dismiss = function () {
          $uibModalInstance.dismiss();
      };

      $scope.save = function () {
          $uibModalInstance.dismiss();
      };

      $scope.dismissAndRedirectBack = function () {
          $uibModalInstance.dismiss();
          if ($scope.data.action !== 'close') {
              $location.path('/home');
          }
      };
  }]);